import './App.css';
import Navbar from "./components/Navbar/Navbar"
import { BrowserRouter,Route,Routes,useLocation } from "react-router-dom" 
import Main from './components/Main/Main';
import MainPeregrino from './pages/Peregrino/MainPeregrino';
import OurHistoryPage from './components/OurHistory/OurHistoryPage';
import Footer from './components/Footer/Footer';
import MainAtonito from './pages/Atonito/MainAtonito';
import MainPais from './pages/Pais/MainPais';
import FamilyProductsPage from './components/ProductFamily/ProductFamilyPage';
import EcologicalCommitment from './components/EcologicalCommitment/EcologicalCommitment';
import MadeForYou from './components/MadeForYou/MadeForYou';


function App() {


  
  return (
    <>
      <BrowserRouter>
      {/* <Navbar />  */}
        <Routes>
            <Route exact path="/" element={[<Navbar />,<Main />, <Footer/>]} />
            <Route exact path='/history' element={[<Navbar />,<OurHistoryPage/>,<Footer/>]}></Route>
            <Route exact path='/productFamily' element={[<Navbar />,<FamilyProductsPage />,<Footer/>]} />
            <Route exact path='/ecologicalCommitment' element={[<Navbar />,<EcologicalCommitment />, <Footer/>]} />
            <Route exact path='/madeForYou' element={[<Navbar />,<MadeForYou />, <Footer/>]} />
            <Route exact path="/peregrino" element={<MainPeregrino />} />
            <Route exact path="/atonito" element={<MainAtonito />} />
            <Route exact path="/pais" element={<MainPais />} />
        </Routes>
      {/* <Footer/> */}
      </BrowserRouter>


    </>
  );
}

export default App;
